import { createContext } from "react";

export interface AccountSession {
  email: string;
  changePasswordHref: string;
  profileHref?: string;
  roleLabel?: string;
  updateProfile?: (name: string) => Promise<void>;
  busy: boolean;
  error: string;
  signOut: () => Promise<void>;
}

export const AccountSessionContext = createContext<AccountSession | null>(null);

export function formatAccountRole(role: string): string {
  const roles: Record<string, string> = { admin: "Platform admin", owner: "Owner", faculty: "Faculty", student: "Student", user: "Member" };
  return role.split(",").map(value => roles[value.trim().toLowerCase()] ?? value.trim()).filter(Boolean).join(", ") || "Member";
}
